<template>
  <el-dialog title="说明" :visible.sync="centerDialogVisible" width="30%" center v-if="type === 1">
    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog title="" :visible.sync="centerDialogVisible" width="30%" class="dialogSelf" v-else-if="type === 2">
    <img :src="dialogImg" alt="" width="100%">
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      dialogImg: '',
      type: 0 // 1显示正常弹框   2 显示图片弹框
    }
  },
  created() {
    this.$eventBus.$on(
      'dialogShow',
      function(type, url) {
        this.type = type
        this.dialogImg = url
        this.centerDialogVisible = true
      }.bind(this)
    )
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/components/Dialog/dialog.vue